'use es6';

import { getEmailSendsLimitMultiplier } from 'pricing-pages-lib/utils/contactsUtils';
import { createSelectorFromUtil } from 'pricing-pages-lib/utils/selectorUtils';
import { getUpgradeProduct } from 'pricing-pages-lib/utils/upgradeProductUtils';
import { FetchProductsRequestTypes } from '../actions/ProductsActions';
import { makeRequestStatusSelector } from './RequestStatusSelectors';
import { PRODUCT_HUBSPOT_FREE } from 'self-service-api/constants/ProductIds';
import { getCrmSuiteProductLevelForSkuIds, getCurrentProductVersion, getCurrentSkuIdForProduct, getHubProductVersionSkuIds, getProduct, getProductForSkuId, getProductVersion, getSkuIdIsInCrmSuite, getHubProductVersionSkuIdsOrDefault, getQuantityPackForProductVersion, getBillingNameKey, getSkuIdIsHub, getHighestProductLevelFromSkuIds, getMaxProductVersionQuantity, getSkuIdIsAddonOrService, getLowestPaidProductLevel, getLowestPaidProductLevelFromList, getPaidProductsLevelsForProductLine, getSkuIdsContainOnlyCRMSuite } from 'pricing-pages-lib/utils/productsUtils';
import { skuMapSelector, transformState } from './SelectorUtils';
import MerchCardsToShow from '../constants/MerchCardsToShow';
export const fetchProductsStatus = makeRequestStatusSelector(FetchProductsRequestTypes.REQUEST);
export const allProductVersionsSelector = ({
  abstractedProducts: {
    productVersions
  }
}) => productVersions;
export const productSelector = createSelectorFromUtil(getProduct, transformState);
/**
 * Selects the product map in a format that is used in ui-addon-upgrades and self-service-api
 */

export const rawProductListSelector = ({
  abstractedProducts: {
    rawProductList
  }
}) => rawProductList;
export const parcelNameToProductIdSelector = ({
  abstractedProducts: {
    parcelNameToProductId
  }
}) => parcelNameToProductId;
export const skuSelector = (state, {
  skuId
}) => {
  const skuMap = skuMapSelector(state);
  return skuMap[skuId];
};
export const productVersionSelector = createSelectorFromUtil(getProductVersion, transformState);
export const currentProductVersionSelector = createSelectorFromUtil(getCurrentProductVersion, transformState);
export const productForSkuIdSelector = createSelectorFromUtil(getProductForSkuId, transformState);
export const currentSkuIdForProductSelector = createSelectorFromUtil(getCurrentSkuIdForProduct, transformState);
export const highlightedSkuIdsSelector = (state, {
  productLine,
  includeFree
}) => {
  const paidSkuIds = MerchCardsToShow[productLine].map(productLevel => currentSkuIdForProductSelector(state, {
    productLine,
    productLevel
  }));

  if (includeFree) {
    return [currentSkuIdForProductSelector(state, {
      productId: PRODUCT_HUBSPOT_FREE
    }), ...paidSkuIds];
  }

  return paidSkuIds;
};
export const billingNameKeySelector = createSelectorFromUtil(getBillingNameKey, transformState);
export const emailSendsLimitMultiplierSelector = createSelectorFromUtil(getEmailSendsLimitMultiplier, transformState);
export const quantityPackForProductVersionSelector = createSelectorFromUtil(getQuantityPackForProductVersion, transformState);
export const crmSuiteProductLevelSelector = createSelectorFromUtil(getCrmSuiteProductLevelForSkuIds, transformState);
export const skuIdIsPartOfCrmSuiteSelector = createSelectorFromUtil(getSkuIdIsInCrmSuite, transformState);
export const skuIdsContainOnlyCrmSuite = createSelectorFromUtil(getSkuIdsContainOnlyCRMSuite, transformState);
export const filteredHubProductVersionSkuIdsSelector = createSelectorFromUtil(getHubProductVersionSkuIds, transformState);
export const filteredHubProductVersionSkuIdsOrDefaultSelector = createSelectorFromUtil(getHubProductVersionSkuIdsOrDefault, transformState);
export const skuIdIsHubSelector = createSelectorFromUtil(getSkuIdIsHub, transformState);
export const highestProductLevelSelector = createSelectorFromUtil(getHighestProductLevelFromSkuIds, transformState);
export const skuIdIsAddonOrServiceSelector = createSelectorFromUtil(getSkuIdIsAddonOrService, transformState);
export const maxProductVersionQuantitySelector = createSelectorFromUtil(getMaxProductVersionQuantity, transformState);
export const lowestPaidProductLevelSelector = createSelectorFromUtil(getLowestPaidProductLevel, transformState);
export const upgradeProductSelector = createSelectorFromUtil(getUpgradeProduct, transformState);
export const lowestPaidProductLevelFromListSelector = createSelectorFromUtil(getLowestPaidProductLevelFromList, transformState);
export const paidProductLevelsForProductLineSelector = createSelectorFromUtil(getPaidProductsLevelsForProductLine, transformState);